"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _index = require("../heading/index");
var _ErrorPage = _interopRequireDefault(require("./ErrorPage.style"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var ErrorPage = function ErrorPage(_ref) {
  var className = _ref.className,
    title = _ref.title,
    text = _ref.text,
    button = _ref.button,
    imageSrc = _ref.imageSrc;
  return /*#__PURE__*/_react["default"].createElement(_ErrorPage["default"], {
    className: className
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "content"
  }, /*#__PURE__*/_react["default"].createElement("img", {
    src: imageSrc,
    alt: "page-error"
  }), /*#__PURE__*/_react["default"].createElement(_index.H1, {
    className: "title"
  }, title), /*#__PURE__*/_react["default"].createElement("div", {
    className: "text"
  }, text), button));
};
ErrorPage.propTypes = {
  className: _propTypes["default"].string,
  title: _propTypes["default"].string.isRequired,
  text: _propTypes["default"].node.isRequired,
  button: _propTypes["default"].node,
  imageSrc: _propTypes["default"].string.isRequired
};
ErrorPage.defaultProps = {
  className: 'error-page',
  button: null
};
var _default = exports["default"] = /*#__PURE__*/(0, _react.memo)(ErrorPage);